import React, { Component } from 'react'

import Promise from 'promise-polyfill'
import { Helmet } from 'react-helmet'
import { hot } from 'react-hot-loader'
import Intercom from 'react-intercom'
import { Provider } from 'react-redux'
import { Router } from 'react-static'
import Routes from 'react-static-routes'
import { createStore } from 'redux'

import Footer from './Footer'
import Header from './Header'
import './app.css'
import './grid.css'
import reducers from './redux/reducers'

if (typeof window !== 'undefined' && !window.Promise) {
  window.Promise = Promise
}

const store = createStore(reducers)

export default hot(module)(
  class App extends Component {
    constructor(props) {
      super(props)
      this.state = {
        loading: true,
      }
    }
    componentDidMount() {
      this.loadingDone()
    }

    loadingDone() {
      this.setState({
        loading: false,
      })
    }

    render() {
      return (
        <div>
          <Helmet>
            <script
              async
              src='https://www.googletagmanager.com/gtag/js?id=G-P91GN1X66R'
            />
            <script type='text/javascript'>{`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-P91GN1X66R');
            `}</script>
          </Helmet>
          {this.state.loading && <div className='spinner' />}
          <Provider store={store}>
            <Router type='browser'>
              <div
                className={this.state.loading ? 'hidden' : 'block'}
                style={{ position: 'relative' }}
              >
                <Header />
                <div className='content'>
                  <Routes />
                  <Intercom appID='msjjl81s' />
                </div>
                <Footer />
              </div>
            </Router>
          </Provider>
        </div>
      )
    }
  },
)



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js